/**
 * 权限点（细粒度）。命名规则：<资源>:<动作>。
 * 路由与接口都按权限点鉴权，而不是直接按角色鉴权 —— 角色只是权限点的集合，
 * 这样后续调整某个角色能做什么时，不需要改动任何业务代码。
 *
 * 注意：本版本只定义到第 5~13 步会用到的资源，后续步骤的权限点在需求明确后追加。
 */
export const PERMISSION = {
    // 委托书（第 5 步：创建 / 第 6 步：审批）
    SHEET_VIEW: 'sheet:view',
    SHEET_CREATE: 'sheet:create',
    SHEET_UPDATE: 'sheet:update',
    SHEET_DELETE: 'sheet:delete',
    SHEET_SUBMIT: 'sheet:submit',
    SHEET_APPROVE: 'sheet:approve',
    SHEET_REJECT: 'sheet:reject',
    /** 商品企划指定本品牌款式的负责人 */
    SHEET_ASSIGN: 'sheet:assign',
    RESPONSIBILITY_VIEW: 'responsibility:view',
    RESPONSIBILITY_MANAGE: 'responsibility:manage',
    INTAKE_VIEW: 'intake:view',
    INTAKE_CORRECT: 'intake:correct',
    INTAKE_CANCEL: 'intake:cancel',
    // 第 7~12 步的明细录入
    SPEC_FABRIC_WIDTH_EDIT: 'spec:fabric-width:edit',
    SPEC_TRIM_ATTR_EDIT: 'spec:trim-attr:edit',
    SPEC_BASE_SIZE_EDIT: 'spec:base-size:edit',
    SPEC_MATERIAL_USAGE_EDIT: 'spec:material-usage:edit',
    SPEC_TRIM_USAGE_EDIT: 'spec:trim-usage:edit',
    SPEC_SIZE_TOLERANCE_EDIT: 'spec:size-tolerance:edit',
    // 编制流程 06 节：QC 委托书
    // 单独一组而不是复用 sheet:update —— QC 的录入者与委托书的编制者不是同一拨人，
    // 且 QC 发生在委托书审批之后，那时 sheet:update 通常已被状态机挡住。
    QC_VIEW: 'qc:view',
    QC_EDIT: 'qc:edit',
    /** 轮次完成。这一步会产生一条 SP0310 报文，所以与录入分开。 */
    QC_CONFIRM: 'qc:confirm',
    // 第 13 步：SAP 数据传送
    SAP_TRANSFER_EXECUTE: 'sap:transfer:execute',
    SAP_TRANSFER_VIEW: 'sap:transfer:view',
    // 成本（P9 D1）。委托书上的成本录入走编辑域 COST，这里只管全公司共用的汇率与成本参数
    COST_CONFIG_MANAGE: 'cost:config:manage',
    // 自建辅料库（P9 D4）。查看给所有看委托书的人（设计师录 BOM 要检索）；
    // 维护给面辅料采购 —— 辅料库建好后由他们在本系统填写辅料信息（2026-09-24 定）
    SUBMATERIAL_VIEW: 'submaterial:view',
    SUBMATERIAL_MANAGE: 'submaterial:manage',
    FABRIC_LIBRARY_VIEW: 'fabric-library:view',
    FABRIC_LIBRARY_MANAGE: 'fabric-library:manage',
    FACTORY_SHARE_MANAGE: 'factory-share:manage',
    /** 维护基础数据字典（商品颜色 / 尺码类别 / 材料颜色）—— 09-30 起默认只给管理员 */
    MASTER_DICT_MANAGE: 'master:dict:manage',
    // 外部接口（EADS ↔ SAP PI）
    INTEGRATION_VIEW: 'integration:view',
    /** 手动探测接口连通性。会真的发一次请求，认证失败计入熔断器，所以单独一个权限点。 */
    INTEGRATION_TEST: 'integration:test',
    // 系统管理
    ADMIN_USER_MANAGE: 'admin:user:manage',
    ADMIN_ROLE_MANAGE: 'admin:role:manage',
    ADMIN_AUDIT_VIEW: 'admin:audit:view',
    ADMIN_BRAND_VIEW: 'admin:brand:view',
    ADMIN_BRAND_MANAGE: 'admin:brand:manage',
};
export const ALL_PERMISSION_CODES = Object.values(PERMISSION);
//# sourceMappingURL=permissions.js.map